export type LabelMap = Record<string, string>;

export const UNKNOWN_LABEL = 'Unknown';

export const ORG_STATUS_LABELS: LabelMap = {
  active: 'Active',
  suspended: 'Suspended',
  cancelled: 'Cancelled',
  pending: 'Pending',
  pending_approval: 'Pending approval',
  approved: 'Approved',
  rejected: 'Rejected',
  deleted: 'Deleted',
};

// Key order is the order role pickers list them in.
export const USER_ROLE_LABELS: LabelMap = {
  user: 'Member',
  org_admin: 'Admin',
  org_owner: 'Owner',
};

export const USER_STATUS_LABELS: LabelMap = {
  active: 'Active',
  invited: 'Invited',
  suspended: 'Suspended',
};

// Key order is the order module pickers list them in.
export const MODULE_LABELS: LabelMap = {
  agents: 'Agents',
  agentic_navigation: 'Agentic navigation',
  phone_agents: 'Phone agents',
  campaigns: 'Campaigns',
  avatar: 'Avatar',
};

export const USE_CASE_LABELS: LabelMap = {
  customer_support: 'Customer support',
  sales: 'Sales & lead generation',
  e_commerce: 'E-commerce',
  hr_operations: 'HR operations',
  healthcare: 'Healthcare',
  finance: 'Finance & banking',
  education: 'Education',
  other: 'Other',
};

export const HOW_HEARD_LABELS: LabelMap = {
  search: 'Search engine',
  social_media: 'Social media',
  referral: 'Referral',
  blog_content: 'Blog or content',
  advertisement: 'Advertisement',
  event: 'Event or conference',
  other: 'Other',
};

export function labelFor(map: LabelMap, raw: string | null | undefined): string {
  if (raw == null) return UNKNOWN_LABEL;
  const key = String(raw).trim();
  if (key === '') return UNKNOWN_LABEL;
  const known = map[key];
  if (known) return known;
  const words = key.replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
}
